export default __webpack_public_path__ + "static/media/castle.b72d2a1b.png";